@if (
  {
    row: columnData | async,
  };
  as $
) {
  <div class="flex align-items-center">
    @if (isBillingStoppedOccurance($.row)) {
      <div class="flex align-items-center">
        <strong class="block p-error">{{
          'SUBSCRIPTIONS.PAYMENT_TIMELINE.STOPPED_BILLING' | translate
        }}</strong>
        <span
          class="border-circle w-2rem h-2rem bg-red-500 flex align-items-center text-white justify-content-center ml-2"
          [pTooltip]="getTooltipMessage($.row)"
          tooltipStyleClass="text-xs"
          aria-label="billing-stopped-badge"
        >
          <i class="fa fa-exclamation-triangle"></i>
        </span>
      </div>
    }
    @if (!isBillingStoppedOccurance($.row) && $.row.payment_status && isfailedPayment($.row)) {
      <div class="flex align-items-center">
        <strong class="block p-error">{{
          $.row.occurance_invoice_id > 0
            ? ($.row.payment_amount_in_minor_currency | currencyformat)
            : ($.row.invoice_amount_in_minor_currency | currencyformat)
        }}</strong>
        @if (
          $.row.occurance_type !== recurringOccuranceType.Recurring &&
          $.row.occurance_type.toString() !==
            recurringOccuranceType[recurringOccuranceType.Recurring]
        ) {
          @if (isFreezeOccurance($.row)) {
            <span
              class="border-circle w-2rem h-2rem bg-red-500 flex align-items-center text-white justify-content-center ml-2"
              [pTooltip]="getTooltipMessage($.row)"
              tooltipStyleClass="text-xs"
              aria-label="freeze-cycle-badge"
            >
              <i class="fa fa-snowflake"></i>
            </span>
          } @else if (isEnhancementOccurance($.row)) {
            <span
              class="border-circle w-2rem h-2rem bg-indigo-500 flex align-items-center text-white justify-content-center ml-2"
              [pTooltip]="getTooltipMessage($.row)"
              tooltipStyleClass="text-xs"
              aria-label="enhancement-cycle-badge"
              data-testid="enhancement-cycle-badge"
            >
              <i class="fa fa-coins"></i>
            </span>
          } @else {
            <span
              class="border-circle w-2rem h-2rem bg-red-500 flex align-items-center text-white justify-content-center ml-2"
              [pTooltip]="getTooltipMessage($.row)"
              tooltipStyleClass="text-xs"
            >
              <i class="fa fa-exclamation-triangle"></i>
            </span>
          }
        }
        @if (
          $.row.occurance_type === recurringOccuranceType.Deposit ||
          $.row.occurance_type.toString() ===
            recurringOccuranceType[recurringOccuranceType.Deposit]
        ) {
          <p-badge
            severity="danger"
            [value]="'DEPOSIT.DEPOSIT' | depositTranslate"
            styleClass="uppercase border-round text-xxs ml-2"
            aria-label="deposit-badge"
          />
        }
        @if (isEnhancementOccurance($.row)) {
          <p-tag
            severity="info"
            [value]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.ENHANCEMENT_TAG' | translate"
            [styleClass]="enhancementTagStyleClass"
            [pTooltip]="getTooltipMessage($.row)"
            tooltipStyleClass="text-xs"
            aria-label="enhancement-timeline-tag"
            data-testid="enhancement-timeline-tag"
          />
        }
      </div>
    }
    @if (!isBillingStoppedOccurance($.row) && $.row.payment_status && isSuccessfulPayment($.row)) {
      <div class="flex align-items-center">
        <strong class="block">{{
          $.row.occurance_invoice_id > 0
            ? ($.row.payment_amount_in_minor_currency | currencyformat)
            : ($.row.invoice_amount_in_minor_currency | currencyformat)
        }}</strong>
        @if (shouldShowIcon($.row)) {
          @if (isFreezeOccurance($.row)) {
            <span
              class="border-circle w-2rem h-2rem bg-green-500 flex align-items-center text-white justify-content-center ml-2"
              [pTooltip]="getTooltipMessage($.row)"
              tooltipStyleClass="text-xs"
              aria-label="freeze-cycle-badge"
            >
              <i class="fa fa-snowflake"></i>
            </span>
          } @else if (isEnhancementOccurance($.row)) {
            <span
              class="border-circle w-2rem h-2rem bg-indigo-500 flex align-items-center text-white justify-content-center ml-2"
              [pTooltip]="getTooltipMessage($.row)"
              tooltipStyleClass="text-xs"
              aria-label="enhancement-cycle-badge"
              data-testid="enhancement-cycle-badge"
            >
              <i class="fa fa-coins"></i>
            </span>
          } @else {
            <span
              class="border-circle w-2rem h-2rem bg-green-500 flex align-items-center text-white justify-content-center ml-2"
              [pTooltip]="getTooltipMessage($.row)"
              tooltipStyleClass="text-xs"
            >
              <i class="fa fa-exclamation-triangle"></i>
            </span>
          }
        }
        @if (
          $.row.occurance_type === recurringOccuranceType.Deposit ||
          $.row.occurance_type.toString() ===
            recurringOccuranceType[recurringOccuranceType.Deposit]
        ) {
          <p-badge
            severity="success"
            [value]="'DEPOSIT.DEPOSIT' | depositTranslate"
            styleClass=" uppercase border-round text-xxs ml-2"
            aria-label="deposit-badge"
          />
        }
        @if (isEnhancementOccurance($.row)) {
          <p-tag
            severity="info"
            [value]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.ENHANCEMENT_TAG' | translate"
            [styleClass]="enhancementTagStyleClass"
            [pTooltip]="getTooltipMessage($.row)"
            tooltipStyleClass="text-xs"
            aria-label="enhancement-timeline-tag"
            data-testid="enhancement-timeline-tag"
          />
        }
      </div>
    }
    @if (
      !isBillingStoppedOccurance($.row) &&
      ($.row.payment_status === paymentStatus.None ||
      $.row.payment_status.toString() === paymentStatus[paymentStatus.None])
    ) {
      <div class="flex align-items-center">
        <span class="block opacity-50">{{
          $.row.invoice_amount_in_minor_currency | currencyformat
        }}</span>
        @if (showBadgeInStatusNoneCase($.row.occurance_type)) {
          @if (isFreezeOccurance($.row)) {
            <span
              class="bg-transparent border-1 border-400 text-700 border-circle w-2rem h-2rem flex align-items-center justify-content-center ml-2"
              [pTooltip]="getTooltipMessage($.row)"
              tooltipStyleClass="text-xs"
              aria-label="freeze-cycle-badge"
            >
              <i class="fa fa-snowflake"></i>
            </span>
          } @else if (isEnhancementOccurance($.row)) {
            <span
              class="bg-transparent border-1 border-indigo-300 text-indigo-600 border-circle w-2rem h-2rem flex align-items-center justify-content-center ml-2"
              [pTooltip]="getTooltipMessage($.row)"
              tooltipStyleClass="text-xs"
              aria-label="enhancement-cycle-badge"
              data-testid="enhancement-cycle-badge"
            >
              <i class="fa fa-coins"></i>
            </span>
          } @else {
            <span
              class="bg-transparent border-1 border-400 text-700 border-circle w-2rem h-2rem flex align-items-center justify-content-center ml-2"
              [pTooltip]="getTooltipMessage($.row)"
              tooltipStyleClass="text-xs"
            >
              <i class="fa fa-exclamation-triangle"></i>
            </span>
          }
        }
        @if (
          $.row.occurance_type === recurringOccuranceType.Deposit ||
          $.row.occurance_type.toString() ===
            recurringOccuranceType[recurringOccuranceType.Deposit]
        ) {
          <p-badge
            severity="success"
            [value]="'DEPOSIT.DEPOSIT' | depositTranslate"
            styleClass="uppercase border-round surface-600 text-white text-xxs ml-2"
            aria-label="deposit-badge"
          />
        }
        @if (
          $.row.occurance_type === recurringOccuranceType.Deposit ||
          $.row.occurance_type.toString() ===
            recurringOccuranceType[recurringOccuranceType.Deposit]
        ) {
          <p-badge
            [severity]="$.row.deposit_applied ? 'success' : ''"
            [value]="
              $.row.deposit_applied
                ? ('DEPOSIT.DEPOSIT_STATUS_APPL' | depositTranslate)
                : ('DEPOSIT.DEPOSIT_STATUS_SCHED' | depositTranslate)
            "
            styleClass="uppercase border-round surface-600 text-white text-xxs ml-2"
          />
        }
        @if (isEnhancementOccurance($.row)) {
          <p-tag
            severity="info"
            [value]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.ENHANCEMENT_TAG' | translate"
            [styleClass]="enhancementTagStyleClass"
            [pTooltip]="getTooltipMessage($.row)"
            tooltipStyleClass="text-xs"
            aria-label="enhancement-timeline-tag"
            data-testid="enhancement-timeline-tag"
          />
        }
      </div>
    }
    @if (!isBillingStoppedOccurance($.row) && isCreatedPayment($.row)) {
      <div class="flex align-items-center">
        <span class="block opacity-50">{{
          $.row.invoice_amount_in_minor_currency | currencyformat
        }}</span>
        @if (isEnhancementOccurance($.row)) {
          <p-tag
            severity="info"
            [value]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.ENHANCEMENT_TAG' | translate"
            [styleClass]="enhancementTagStyleClass"
            [pTooltip]="getTooltipMessage($.row)"
            tooltipStyleClass="text-xs"
            aria-label="enhancement-timeline-tag"
            data-testid="enhancement-timeline-tag"
          />
        }
      </div>
    }
  </div>
}
